module.exports = __webpack_public_path__ + "img/chalk_15.b41dbdae.png";